export default class Timer {

    static timers = {}

    static start(type) {
        Timer.timers[type] = Date.now()
    }

    static stop(type) {
        const start = Timer.timers[type]
        if (start === undefined) throw new Error('Timer not started')
        const stop = Date.now()
        const duration = stop - start
        delete Timer.timers[type]
        return duration
    }
}